import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["moneyGrantedFields", "cmeFields", "eventInvitationFields", "otherFields", "slots", "moneyPerApplicant", "totalAmount"]

  connect() {
    this.showFieldsForSelectedType()
    this.calculateTotal()
  }

  showFieldsForSelectedType() {
    // Get the selected radio button
    const selectedRadio = this.element.querySelector('input[name*="[offer_type]"]:checked')
    
    if (!selectedRadio) {
      this.hideAllFields()
      return
    }

    const selectedType = selectedRadio.value
    this.hideAllFields()
    this.showFieldsForType(selectedType)
  }

  hideAllFields() {
    if (this.hasMoneyGrantedFieldsTarget) {
      this.moneyGrantedFieldsTarget.style.display = 'none'
    }
    if (this.hasCmeFieldsTarget) {
      this.cmeFieldsTarget.style.display = 'none'
    }
    if (this.hasEventInvitationFieldsTarget) {
      this.eventInvitationFieldsTarget.style.display = 'none'
    }
    if (this.hasOtherFieldsTarget) {
      this.otherFieldsTarget.style.display = 'none'
    }
  }

  showFieldsForType(type) {
    switch(type) {
      case 'money_granted':
        if (this.hasMoneyGrantedFieldsTarget) {
          this.moneyGrantedFieldsTarget.style.display = 'block'
        }
        break
      case 'cme':
        if (this.hasCmeFieldsTarget) {
          this.cmeFieldsTarget.style.display = 'block'
        }
        break
      case 'event_invitation':
        if (this.hasEventInvitationFieldsTarget) {
          this.eventInvitationFieldsTarget.style.display = 'block'
        }
        break
      case 'other':
        if (this.hasOtherFieldsTarget) {
          this.otherFieldsTarget.style.display = 'block'
        }
        break
    }
  }

  typeChanged() {
    this.clearDynamicFields()
    this.showFieldsForSelectedType()
    this.calculateTotal()
  }

  clearDynamicFields() {
    // Clear money granted field
    if (this.hasMoneyPerApplicantTarget) {
      this.moneyPerApplicantTarget.value = ''
    }
    
    // Add clearing logic for future fields here
    // For CME, Event Invitation, Other fields
  }

  calculateTotal() {
    if (!this.hasSlotsTarget || !this.hasMoneyPerApplicantTarget || !this.hasTotalAmountTarget) {
      return
    }

    const slots = parseFloat(this.slotsTarget.value) || 0
    const moneyPerApplicant = parseFloat(this.moneyPerApplicantTarget.value) || 0
    const total = slots * moneyPerApplicant

    this.totalAmountTarget.innerHTML = `Total Amount of Money Granted: <span>$${this.formatMoney(total)}</span>`
  }

  formatMoney(amount) {
    return amount.toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    })
  }
}
